export default defineNuxtPlugin(() => {
  if (useAppEnv().isTesting) return
  const { tracking } = useSettings()
  const widgetId = tracking?.digitalGeniusWidgetId
  const env = tracking?.digitalGeniusEnv ?? 'eu'
  if (!widgetId) return

  useHead({
    script: [
      {
        key: 'dg-config',
        innerHTML: `window.DG_CHAT_WIDGET_CONFIG = { widgetId: "${widgetId}", env: "${env}" };`,
      },
      {
        key: 'dg-init',
        src: 'https://chat.digitalgenius.com/init.js',
        async: true,
        defer: true,
        onload: 'window.dgchat.init();',
      },
    ],
  })
})
